import React from 'react'
import styled, { css } from 'styled-components'
import { Copy, IconArrowDown, Typography, ScrollView } from '../../../Common'
import Collapse from '@kunukn/react-collapse'

export const TabContent = ({
  open,
  isComponent,
  content,
}: {
  open?: boolean
  isComponent?: boolean
  content: any
}) => {
  return (
    <Wrapper open={open}>
      <Collapse
        isOpen={open}
        transition="height 290ms cubic-bezier(.4, 0, .2, 1)"
      >
        <ScrollView maxHeight="32rem">
          {isComponent ? (
            <Content open={open}>{content}</Content>
          ) : (
            <Content open={open}>
              <Copy html={content} />
            </Content>
          )}
        </ScrollView>
      </Collapse>
    </Wrapper>
  )
}

export const TabListItem = (props: {
  tab: {
    content: any
    isComponent?: boolean
    headerComponent?: any
    name: string
  }
  onClick: (name: string) => () => void
  open?: boolean
}) => {
  const { tab, open, onClick } = props

  return (
    <Container>
      <ListItem open={open} role="button" onClick={onClick(tab.name)}>
        {tab.isComponent && tab.headerComponent}

        {!tab.isComponent && <ItemLabel>{tab.name}</ItemLabel>}

        <IconWrapper open={open}>
          <IconArrowDown width="24" height="24" />
        </IconWrapper>
      </ListItem>
      <ContentContainer>
        <TabContent
          open={open}
          isComponent={tab.isComponent}
          content={tab.content}
        />
      </ContentContainer>
    </Container>
  )
}

type Props = {
  open?: boolean
  expanded?: boolean
  hide?: boolean
  showExpand?: boolean
}

const Wrapper = styled.div<Props>`
  position: relative;
  overflow: initial;

  ${(props) =>
    props.open &&
    `
    overflow: hidden;
  `};
`

const ContentContainer = styled.div.attrs({
  className: 'px-3',
})``

const Container = styled.div<Props>`
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  &:last-child {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }
`

const Content = styled.div.attrs({
  className: 'py-3',
})<Props>`
  position: absolute;
  opacity: 0;
  width: 100%;
  max-height: 0;
  visibility: hidden;

  ${(props) =>
    props.open &&
    css`
      position: relative;
      opacity: 1;
      visibility: visible;
      max-height: 32rem;
    `};
`

const ListItem = styled(Typography).attrs({
  as: 'div',
  variant: 4,
  className: 'py-4 px-3',
})<Props>`
  transition: background-color 0.15s ease, color 0.15s ease;
  color: ${({ theme }) => theme.palette.greyTitle};
  display: flex;
  cursor: pointer;
`

const ItemLabel = styled(Typography).attrs({
  as: 'p',
  variant: 6,
})<any>`
  font-weight: inherit;
  color: inherit;
  line-height: 1.8;
`

const IconWrapper = styled.div.attrs({
  className: 'ml-auto pl-3',
})<Props>`
  & svg {
    transform: rotate(0);
    position: relative;
    top: 0;
    right: 0;
    color: ${({ theme }) => theme.palette.greyTitle};

    ${(props) =>
      props.open &&
      `
        transform: rotate(180deg);
        top: 0.4rem;
      `}
  }
`
